import { get, post, put, del } from 'services/api-client';

const surveyService = {
  getAsSelectListItems: (clientId, isForFilter) => get(`/tag/select-list?clientId=${clientId}&isForFilter=${isForFilter}`),

  create: (data) => post('/tag/create', data),

  update: (data) => put('/tag/update', data),

  delete: (id) => del(`/tag/${id}/delete`),

  getForForm: (id) => get(`/tag/${id}/form`)
}

export default surveyService;